"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalkonkabineJust = exports.MeerblickkabineJust = exports.InnenkabineJust = exports.SuitePremium = exports.PremiumSuite = exports.PanoramaSuite = exports.PanoramaDeluxeSuite = exports.JuniorSuiteDeluxe = exports.DeluxeSuite = exports.LanaikabineVL = exports.BalkonkabineVP = exports.BalkonkabinePanoramaBS = exports.BalkonkabinePanoramaBP = exports.VerandakabinePremiumKomfortWithExtraSpaceVF = exports.VerandakabinePremiumKomfortWithExtraSpaceVC = exports.VerandakabinePremiumKomfortWithWarlkinWardrobeVE = exports.VerandakabinePremiumKomfortWithWarlkinWardrobeVB = exports.VerandakabinePremiumKomfortWithTwoBathsVD = exports.VerandakabinePremiumKomfortWithTwoBathsVA = exports.VerandakabinePremiumVH = exports.VerandakabinePremiumVG = exports.BalkonkabinePremiumBB = exports.BalkonkabinePremiumBA = exports.MeerblickkabineLimitedVisibility = exports.MeerblickkabineMD = exports.MeerblickkabineMC = exports.MeerblickkabineMB = exports.MeerblickkabineMA = exports.InnenkabinePremiumIB = exports.InnenkabinePremiumIA = exports.SuiteVario = exports.PanoramakabineVario = exports.PanoramaBalkonkabineVario = exports.VerandakabineKomfortVario = exports.VerandakabineVario = exports.BalkonkabineVario = exports.MeerblickkabineVario = exports.InnenkabineVario = exports.Familienkabine = exports.VerandakabineDeluxe = exports.JuniorSuite = exports.VerandakabineKomfort = exports.Suite = exports.Lanaikabine = exports.PanoramaBalkonkabine = exports.Panoramakabine = exports.Verandakabine = exports.Balkonkabine = exports.Meerblickkabine = exports.Innenkabine = void 0;
exports.VerandakabineKomfortSeetours = exports.VerandakabineSeetours = exports.BalkonkabineSeetours = exports.MeerblickkabineSeetoursMV = exports.MeerblickkabineSeetoursAV = exports.InnenkabineSeetours = exports.VerandakabineKomfortPauschal = exports.VerandakabinePauschal = exports.BalkonkabinePauschal = exports.MeerblickkabinePauschal = exports.InnenkabinePauschal = void 0;
exports.Innenkabine = 'I'; // all ships
exports.Meerblickkabine = 'M'; // all ships
exports.Balkonkabine = 'B'; // all ships except AIDAprima/AIDAperla
exports.Verandakabine = 'V'; // only AIDAprima/AIDAperla
exports.Panoramakabine = 'P'; // only AIDAprima/AIDAperla
exports.PanoramaBalkonkabine = 'W'; // only AIDAblu, mar, sol, stella
exports.Lanaikabine = 'L'; // only AIDAprima/AIDAperla
exports.Suite = 'S'; // all ships
exports.VerandakabineKomfort = 'K';
exports.JuniorSuite = 'J';
exports.VerandakabineDeluxe = 'D';
exports.Familienkabine = 'F';
// Vario
exports.InnenkabineVario = 'IV';
exports.MeerblickkabineVario = 'MV';
exports.BalkonkabineVario = 'BV';
exports.VerandakabineVario = 'VV';
exports.VerandakabineKomfortVario = 'KV';
exports.PanoramaBalkonkabineVario = 'WV';
exports.PanoramakabineVario = 'PV';
exports.SuiteVario = 'SV';
// Permium Innenkabine
exports.InnenkabinePremiumIA = 'IA';
exports.InnenkabinePremiumIB = 'IB';
// Permium Meerblickkabine
exports.MeerblickkabineMA = 'MA';
exports.MeerblickkabineMB = 'MB';
exports.MeerblickkabineMC = 'MC';
exports.MeerblickkabineMD = 'MD';
// limited visibility
exports.MeerblickkabineLimitedVisibility = 'CA';
// Premium Balkonkabine
exports.BalkonkabinePremiumBA = 'BA';
exports.BalkonkabinePremiumBB = 'BB';
// Premium Verandakabine
exports.VerandakabinePremiumVG = 'VG';
exports.VerandakabinePremiumVH = 'VH';
exports.VerandakabinePremiumKomfortWithTwoBathsVA = 'VA';
exports.VerandakabinePremiumKomfortWithTwoBathsVD = 'VD';
exports.VerandakabinePremiumKomfortWithWarlkinWardrobeVB = 'VB';
exports.VerandakabinePremiumKomfortWithWarlkinWardrobeVE = 'VE';
exports.VerandakabinePremiumKomfortWithExtraSpaceVC = 'VC';
exports.VerandakabinePremiumKomfortWithExtraSpaceVF = 'VF';
// Premium Panorama-Balkonkabine
exports.BalkonkabinePanoramaBP = 'BP';
exports.BalkonkabinePanoramaBS = 'BS';
// Permium Panoramakabine
exports.BalkonkabineVP = 'VP';
// Premium Lanaikabine
exports.LanaikabineVL = 'VL';
// Premium Suite
exports.DeluxeSuite = 'SA';
exports.JuniorSuiteDeluxe = 'SD';
exports.PanoramaDeluxeSuite = 'SX';
exports.PanoramaSuite = 'SP';
exports.PremiumSuite = 'SB';
exports.SuitePremium = 'SC';
// Just
exports.InnenkabineJust = 'IJ';
exports.MeerblickkabineJust = 'MJ';
exports.BalkonkabineJust = 'BJ';
// TODO VerandakabineJust
// TODO VerandakabineKomfortJust
// Pauschal
exports.InnenkabinePauschal = 'IV';
exports.MeerblickkabinePauschal = 'MV';
exports.BalkonkabinePauschal = 'BV';
exports.VerandakabinePauschal = 'VV';
exports.VerandakabineKomfortPauschal = 'KV';
// Seetours
exports.InnenkabineSeetours = 'IV';
exports.MeerblickkabineSeetoursAV = 'AV';
exports.MeerblickkabineSeetoursMV = 'MV';
exports.BalkonkabineSeetours = 'BV';
exports.VerandakabineSeetours = 'VV';
exports.VerandakabineKomfortSeetours = 'KV';
//# sourceMappingURL=cabin_category.js.map